import Sticky from 'sticky-js'

/* Options
   wrap: options.wrap || false,
   wrapWith: options.wrapWith || '<span></span>',
   marginTop: options.marginTop || 0,
   marginBottom: options.marginBottom || 0,
   stickyFor: options.stickyFor || 0,
   stickyClass: options.stickyClass || null,
   stickyContainer: options.stickyContainer || 'body',
*/

const heroHeight = document.querySelector('#heroSection').offsetHeight

const stickySocial = new Sticky('.socialShare.-sticky', {
    marginTop: heroHeight + 120,
    stickyFor: 816,
    stickyClass: '-stickyStuck',
    stickyContainer: 'main',
})
